import React, { useState, useEffect } from "react";
import SelectCategory from "./selectCategory";
import CategoryContent from "./categoryContent";
import { useSelector } from "react-redux";

import Socket from "../../../socket/socket";
import _ from "lodash";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

const buttonData = [
  { title: "All Categories" },
  { title: "Daily Life" },
  { title: "Funny" },
  { title: "Random" },
  { title: "Work & Education" },
];

const IceBreakers = (props) => {
  const { type } = props;
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const roomData = _.get(props, "gameReducer.roomObj");
  const ib_open = _.get(roomData, "lobby_parameters.ib_open");
  const ib_category = _.get(roomData, "lobby_parameters.ib_category", null);
  // ice breaker for avatar
  const toggleicebreaker = () => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      ib_open: !isOpen,
    };
    Socket.sendMessage(data);
  };
  useEffect(() => {
    setIsOpen(ib_open);
  }, [ib_open]);

  useEffect(() => {
    if (ib_category !== null) {
      const index = buttonData.findIndex((item) => item.title === ib_category);
      setSelectedIndex(index);
    }
  }, [ib_category]);

  const toggleIceBreaker = () => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      ib_open: !isOpen,
    };
    Socket.sendMessage(data);
  };

  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      ib_category: buttonData[selectedIndex]?.title,
    };
    Socket.sendMessage(data);
  }, [selectedIndex]);

  return (
    <div className={`lobby-sidebar-wrapper ${type}`}>
      <button onClick={toggleIceBreaker} className="ice-breaker-btn">
        <i className={`fas fa-angle-double-${isOpen ? "down" : "up"} mr-3`} />
        <span className="icetext">Icebreakers</span>
        {/* {type === 'tot'? 'Icebreakers' : 'Icebreakers'}  */}
      </button>
      {isOpen === true && (
        <div className={`lobby-sidebar ${isOpen === true ? "visible" : ""}`}>
          <div
            className={`lobby-sidebar-content ${
              selectedIndex === null ? "borderLeft" : ""
            }`}
          >
            {selectedIndex === null ? (
              <SelectCategory
                buttonData={buttonData}
                selectedIndex={selectedIndex}
                onClickItem={setSelectedIndex}
                type={type}
              />
            ) : (
              <CategoryContent
                roomData={roomData}
                buttonData={buttonData}
                selectedIndex={selectedIndex}
                onClickItem={setSelectedIndex}
                type={type}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  socketReducer: state.socketReducer,
});

export default compose(withRouter, connect(mapStateToProps))(IceBreakers);
